import { useEffect, useRef } from "react";
import { trackEvent } from "./mixpanel";

export const useScreenTracking = (eventName, properties = {}) => {
    const startTime = useRef(Date.now());

    useEffect(() => {
        startTime.current = Date.now();

        return () => {
            const timeSpent = Math.round(
                (Date.now() - startTime.current) / 1000
            );

            trackEvent(eventName, {
                ...properties,
                "Time spent on screen": timeSpent,
            });
        };
    }, []);

    const getTimeSpent = () => {
        return Math.round(
            (Date.now() - startTime.current) / 1000
        );
    };

    return {
        getTimeSpent,
    };
};